import _ from 'lodash';
import {
    Groups6, IWorkspaceCreationRequest, IWorkspaceUpdateRequest,
    Workspace, WorkspaceBulkAssignApplicationsRequest, WorkspaceBulkAssignGroupsRequest, WorkspaceBulkDeleteRequest,
    WorkspaceCollection, WorkspaceCreationRequest, WorkspacesClient, WorkspaceUpdateRequest,
} from '../clients/aasServerClient.generated';
import { TableFilters, TableSorting } from '../stores/tables/state';

export function getWorkspaces(
    limit: number, start: number,
    sorting: TableSorting,
    filters: TableFilters,
    searchString?: string
): Promise<WorkspaceCollection> {
    const ordering = `${sorting.column} ${sorting.order}`;
    const client = new WorkspacesClient(process.env.PUBLIC_URL + '/api');
    return client.getWorkspaces(
        false, true,
        limit, start, ordering,
        filters.u, filters.a, filters.g,
        searchString
    );
}

export function getWorkspacesNF(
    limit: number, start: number,
    sorting: TableSorting,
): Promise<WorkspaceCollection> {
    const ordering = `${sorting.column} ${sorting.order}`;
    const client = new WorkspacesClient(process.env.PUBLIC_URL + '/api');
    return client.getWorkspaces(
        false, true,
        limit, start, ordering,
        undefined, undefined,undefined,
        undefined
    );
}

export function getAllWorkspaces(): Promise<WorkspaceCollection> {
    const client = new WorkspacesClient(process.env.PUBLIC_URL + '/api');
    return client.getWorkspaces(
        true, undefined,
        undefined, undefined, undefined, undefined,
        undefined, undefined, undefined,
    );
}

export function getWorkspace(id: string): Promise<Workspace> {
    const client = new WorkspacesClient(process.env.PUBLIC_URL + '/api');
    return client.getWorkspace(id);
}

export function updateWorkspace(
    workspace: Partial<Workspace>,
    parentId?: string,
    groups?: Array<{ id: string, value: boolean }>,
): Promise<Workspace> {
    const client = new WorkspacesClient(process.env.PUBLIC_URL + '/api');
    const data: IWorkspaceUpdateRequest =
        _.assign(workspace, {
            groups: groups ? groups.map((g) => new Groups6(g)) : undefined,
            parent_id: parentId,
            // tslint:disable-next-line: no-any
            user_limit: workspace.user_limit === null || (workspace.user_limit as any) === '' ?
                null : workspace.user_limit,
        }) as unknown as IWorkspaceUpdateRequest;
    return client.updateWorkspace(workspace.id!, new WorkspaceUpdateRequest(data));
}

export function createWorkspace(
    workspace: Partial<Workspace>,
    parentId?: string,
    groups?: Array<{ id: string, value: boolean }>,
): Promise<Workspace> {
    const client = new WorkspacesClient(process.env.PUBLIC_URL + '/api');
    const data: IWorkspaceCreationRequest =
        _.assign(workspace, {
            groups: groups ? groups.map((g) => new Groups6(g)) : undefined,
            parent_id: parentId,
        }) as unknown as IWorkspaceCreationRequest;
    return client.createWorkspace(new WorkspaceCreationRequest(data));
}

export function deleteWorkspaces(ids: string[]) {
    const client = new WorkspacesClient(process.env.PUBLIC_URL + '/api');
    return client.bulkDeleteWorkspaces(new WorkspaceBulkDeleteRequest({ ids }));
}

export function assignGroupsWorkspaces(workspaceIds: string[], groupIds: string[]) {
    const client = new WorkspacesClient(process.env.PUBLIC_URL + '/api');
    return client.bulkAssignGroups(
        new WorkspaceBulkAssignGroupsRequest({ workspaces: workspaceIds, groups: groupIds })
    );
}

export function assignApplicationsWorkspace(workspaceId: string, applicationIds: string[]) {
    const client = new WorkspacesClient(process.env.PUBLIC_URL + '/api');
    return client.bulkAssignApplications(
        new WorkspaceBulkAssignApplicationsRequest({ workspaces: [workspaceId], applications: applicationIds })
    );
}
